module.exports = "/src/views/player/hudevo/phonenew/assets/images/call.png";